function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import Modal from 'components/Modal';
import App, { AlertsBus } from 'modules/App';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
import InviteFamilyMembersForm from '../../partials/InviteFamilyMembersForm';
import styles from './InviteFamilyMembersModal.pcss';
var _React_PureComponent;
class InviteFamilyMembersModal extends (_React_PureComponent = React.PureComponent) {
    static getDerivedStateFromProps(props, state) {
        const { isInProgress, hasErrors } = props;
        if (isInProgress !== state.isInProgress && (isInProgress || hasErrors)) {
            return {
                isInProgress
            };
        }
        return null;
    }
    componentDidUpdate(prevProps) {
        const { isInProgress, hasErrors } = this.props;
        if (prevProps.isInProgress !== isInProgress && !isInProgress && !hasErrors) {
            this.onClose();
        }
    }
    async onClose() {
        await this.props.onCloseModal();
        this.props.onClearForm();
        this.setState({
            isInProgress: false
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs(Modal, {
            modalId: constants.INVITE_FAMILY_MEMBERS_MODAL,
            openModalId: this.props.openModalId,
            styleModifier: "md",
            onClose: ()=>this.onClose(),
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: cn('modal__header', styles.header),
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.inviteFamilyMembers))
                }),
                /*#__PURE__*/ _jsx(AlertsBus, {
                    className: "mb-4"
                }),
                /*#__PURE__*/ _jsx(InviteFamilyMembersForm, {
                    persons: 1,
                    isInProgress: this.state.isInProgress
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            isInProgress: false
        };
    }
}
_define_property(InviteFamilyMembersModal, "propTypes", {
    // Implicit props
    formValues: PropTypes.object,
    isInProgress: PropTypes.bool,
    hasErrors: PropTypes.bool,
    openModalId: PropTypes.string,
    // Implicit actions
    onClearForm: PropTypes.func,
    onCloseModal: PropTypes.func
});
const inviteFamilyMembersFormSelector = App.selectors.formSelector(constants.INVITE_FAMILY_MEMBERS_FORM);
const mapStateToProps = (state)=>({
        isInProgress: selectors.isInviteFamilyMembersInProgress(state),
        hasErrors: selectors.hasInviteFamilyMembersErrors(state),
        formValues: inviteFamilyMembersFormSelector(state),
        openModalId: App.selectors.modal(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onClearForm: ()=>dispatch(App.actions.clearForm(constants.INVITE_FAMILY_MEMBERS_FORM)),
        onCloseModal: ()=>dispatch(App.actions.closeModal())
    });
const ConnectedInviteFamilyMembersModal = connect(mapStateToProps, mapDispatchToProps)(InviteFamilyMembersModal);
export default withStyles(styles)(ConnectedInviteFamilyMembersModal);
